import React, {useContext, useState, useEffect} from "react";
import {Content} from "../../styles/GlobalStyles";
import AuthContainer from "../../containers/AuthContainer";
import {ContentAuth, TitleAuth, CardAuth, TextAuth} from "./components/AuthStyles";
import LoginOptions from "./components/LoginOptions";
import {useHistory, useLocation} from "react-router-dom";
import {GlobalContext} from "../../context/GlobalContext";
import {LoginService} from "../../services/UserServices";
import AppLoader from "../../components/loaders/Loader";
import Text from "../../styles/Text";

export default function LoginView() {
   let history = useHistory();
   let location = useLocation();
   const [isLoading, setLoading] = useState(false);
   const {setToken, sessionStarted} = useContext(GlobalContext);
   const [errorLogin, setErroLogin] = useState("");
   const [errorSocial, setErrorSocial] = useState("");

   useEffect(() => {
      // leer cambios en el status de la sesión
      if (sessionStarted) {
         // si hay una página previa regresar o al inicio
         history.replace(location.state ? `${location.state.prev}` : "/");
      }
   }, [sessionStarted]);

   const doLogin = (dataLogin, remember, type = "email") => {
      setLoading(true);
      setErroLogin("");
      setErrorSocial("");
      let {email, pwd} = dataLogin;
      let toSend = {email, pwd};
      LoginService(toSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            console.log(resp);

            if (status === "error") {
               if (type === "email") {
                  setErroLogin("Revisa tu correo o contraseña");
               } else {
                  setErrorSocial("Usuario no registrado");
               }
            }

            if (remember) {
               // si selecciono RECORDAR guardar el token
               localStorage.setItem("domecq_token", data.token);
            }
            setToken(data.token);
         })
         .then(() => {
            setLoading(false);
         })
         .catch((e) => {
            console.log(e);
            setLoading(false);
         });

      /*  */
   };
   return (
      <>
         <AuthContainer>
            <Content>
               <ContentAuth>
                  <CardAuth>
                     <div className="head">
                        <TitleAuth>Iniciar sesión</TitleAuth>
                        <TextAuth>¿Eres nuevo en Domecq Academy?</TextAuth>
                     </div>
                     <LoginOptions doLogin={doLogin} errorLogin={errorLogin} errorSocial={errorSocial} />
                  </CardAuth>
               </ContentAuth>
            </Content>
         </AuthContainer>
         <AppLoader isVisible={isLoading} />
      </>
   );
}
